/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import {InputGroup} from "react-bootstrap";
import {AsyncTypeahead} from "react-bootstrap-typeahead";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/pro-solid-svg-icons";

import {useDispatch, useSelector} from "react-redux";

import {getManagedMatchTemplatesWithFilter} from "../../match-templates/managedMatchTemplatesSlice";
import TextHoverDisplay from "../../../common/components/TextHoverDisplay";

import {isArray} from "lodash";
import FormLabel from "../../../common/components/form/FormLabel";
import FormRequiredText from "../../../common/components/form/FormRequiredText";

const FormSearchMatchTemplateTypeahead = (props) => {
    const {
        label,
        matchTemplate,
        onChange,
        isInvalid,
        editing,
        required
    } = props;

    const dispatch = useDispatch();
    const managedMatchTemplatesState = useSelector(state => state.managedMatchTemplates);

    const searchManageMatchTemplates = (search) => {
        const query = {
            filter: {
                // include: ['matchType'],
                where: {
                    and: [
                        {
                            or: [{
                                name: {
                                    ilike: `%${search ? search : ''}%`
                                }
                            }]
                        }
                    ]
                }
            },
        };

        dispatch(getManagedMatchTemplatesWithFilter(query));
    };

    return (
        <>
            {label && (
                <FormLabel>
                    {label}
                    {required && (
                        <FormRequiredText> *</FormRequiredText>
                    )}
                </FormLabel>
            )}
            { editing ? (
                <InputGroup>
                    <InputGroup.Text id="basic-addon1">
                        <FontAwesomeIcon icon={faSearch} style={{fontSize: '16px'}} />
                    </InputGroup.Text>
                    <AsyncTypeahead
                        id="search-matchTemple-typeahead"
                        isLoading={managedMatchTemplatesState.loading}
                        labelKey={(option) => (option && option.matchType ? `${option.matchType.display} - ${option.name}` : 'name')}
                        minLength={1}
                        onSearch={searchManageMatchTemplates}
                        options={managedMatchTemplatesState.managedMatchTemplates}
                        placeholder="Search match templates..."
                        renderMenuItemChildren={(option) => (
                            <div key={option.id}>
                                <span>{`${option.matchType.display} - ${option.name}`}</span>
                            </div>
                        )}
                        onChange={onChange}
                        selected={matchTemplate}
                        clearButton
                        isInvalid={isInvalid}
                    />
                </InputGroup>
            ) : (
                <TextHoverDisplay
                    fullText={isArray(matchTemplate) ? matchTemplate[0]?.id : matchTemplate?.id }
                    truncatedText={isArray(matchTemplate) ? matchTemplate[0]?.id : matchTemplate?.id}
                    displayTruncated={false}
                />
            )}
        </>
    )
}

export default FormSearchMatchTemplateTypeahead;
